fragment LargeImageFeatureFragment on largeImageFeature_Entry {
  typeHandle
  mainHeading
  heading
  body
  image {
    ...CraftAssetFragment
  }
  alt
  cta {
    ...LinkFragment
  }
}
